import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { pdf } from '@react-pdf/renderer';
import Access from "./Components/Access";
import IncidendesFinancieresGlobalOperations from "./Components/IncidendesFinancieresGlobalOperations";
import Navbar from "./Components/Navbar";
import GanttSyntheseOperations from "./Components/GanttSyntheseOperations";
import { addSpace } from "./Components/Tools";
import {NotificationManager} from 'react-notifications';
import { ReactComponent as Trash } from './Img/icon-trash.svg';
import { ReactComponent as Add } from './Img/icon-add.svg';
import { useHistory } from 'react-router-dom';
import Dialog from "./Components/Dialog";
import FacturePortagePDF from "./Components/FacturePortagePDF";
import AvisEcheancePDF from "./Components/AvisEcheancePDF";
import FacturationSelectionPDF from "./Components/FacturationSelectionPDF";

const Operations = (props) =>
{
    const history = useHistory();
    const [aff, setAff] = useState(false);
    const [operations, setOperations] = useState([]);
    const [modalites, setModalites] = useState([]);
    const [axes, setAxes] = useState([]);
    const [territoires, setTerritoires] = useState([]);
    const [clients, setClients] = useState([]);
    const [modaliteFilter, setModaliteFilter] = useState('');
    const [axeFilter, setAxeFilter] = useState('');
    const [territoireFilter, setTerritoireFilter] = useState('');
    const [clientFilter, setClientFilter] = useState('');
    const [searchText, setSearchText] = useState('');
    const [searchNumero, setSearchNumero] = useState('');
    const [hypotheseFilter, setHypotheseFilter] = useState('');
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    const [idSelected, setIdSelected] = useState(null);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');
    const [selectedOperations, setSelectedOperations] = useState({});
    const [generationModalVisible, setGenerationModalVisible] = useState(false);
    const [generationType, setGenerationType] = useState(null); // 'factures' | 'avis'
    const [pendingOperations, setPendingOperations] = useState([]);
    const [isGenerating, setIsGenerating] = useState(false);
    const [ongletListeOperations, setOngletListeOperations] = useState(true);
    const [ongletSyntheseGantt, setOngletSyntheseGantt] = useState(false);
    const [ongletIncidencesFinancieres, setOngletIncidencesFinancieres] = useState(false);
    const [ongletFacturationEpfl, setOngletFacturationEpfl] = useState(false);
    const [anneeDebut, setAnneeDebut] = useState('');
    const [anneeFin, setAnneeFin] = useState('');
    const [annees, setAnnees] = useState([]);
    const [anneeSelectionnee, setAnneeSelectionnee] = useState(null);
    const [isRecalculating, setIsRecalculating] = useState(false);
    const [iban, setIban] = useState('');
    const [bic, setBic] = useState('');
    const [logo, setLogo] = useState('');
    const [tamponSignature, setTamponSignature] = useState('');
    const [num_voie, setNum_voie] = useState(null);
    const [num_suffixe, setNum_suffixe] = useState(null);
    const [type_voie, setType_voie] = useState(null);
    const [nom_voie, setNom_voie] = useState(null);
    const [complement_adresse, setComplement_adresse] = useState(null);
    const [code_postale, setCode_postale] = useState(null);
    const [ville, setVille] = useState(null);
    const [telephone, setTelephone] = useState('');
    const [emailContact, setEmailContact] = useState('');
    const [piedPage, setPiedPage] = useState('');

    const purple = '#6571FE';
    const green = '#59B44A';
    

    async function callbackDialog(ret) {
        if (ret === true) {
            await suppressProjet(idSelected);
        }
        await setIdSelected(null);
    }

    async function mount()
    {
        if (!props.user) return;

        // Initialiser les années de début et fin
        if (props.user.config_budget) {
            if (props.user.config_budget.retro_an_deb) {
                setAnneeDebut(props.user.config_budget.retro_an_deb);
            }
            if (props.user.config_budget.prosp_an_fin) {
                setAnneeFin(props.user.config_budget.prosp_an_fin);
            }

            // Récupération des années de retro pour la selection des années des factures
            const debut = props.user.config_budget.retro_an_deb;
            const fin = props.user.config_budget.prosp_an_fin;
            var annees = [];
            for (let i = debut; i <= fin; i++) {
                annees.push(parseInt(i));
            }
            setAnnees(annees);
        }

        // liste des opérations de l'id_budget
        try {
            const res = await axios.post('/api/operations.php', qs.stringify({ get: true, id_budget: props.user.id_budget }));
            if (res && res.data) {
                // API returns { status:1, count:, data: [...] } or similar
                let list = Array.isArray(res.data) ? res.data : (res.data.data ? res.data.data : []);
                
                // Filtrer par droits de visualisation si l'utilisateur est de type 3 (simple user)
                if (props.user.id_type_users == 3) {
                    list = list.filter(op => {
                        const droits_visu = (op.id_users_droits_visu || '').split(';').map(id => id.trim()).filter(id => id !== '');
                        return droits_visu.includes(String(props.user.id));
                    });
                }
                
                setOperations(list || []);
            } else setOperations([]);
        }
        catch (err) {
            console.warn(err);
            setOperations([]);
        }


        // modalites (pour filtre) — on utilise id_organisme comme les autres pages
        try {
            const rm = await axios.post('/api/modalites_portage.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (rm && rm.data) setModalites(Array.isArray(rm.data) ? rm.data : (rm.data.data ? rm.data.data : []));
            else setModalites([]);
        }
        catch (err) {
            console.warn(err);
            setModalites([]);
        }

        // axes d'interventions
        try {
            const ra = await axios.post('/api/axes_interventions.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (ra && ra.data) setAxes(Array.isArray(ra.data) ? ra.data : (ra.data.data ? ra.data.data : []));
            else setAxes([]);
        }
        catch (err) {
            console.warn(err);
            setAxes([]);
        }

        // territoires
        try {
            const rt = await axios.post('/api/territoires.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (rt && rt.data) setTerritoires(Array.isArray(rt.data) ? rt.data : (rt.data.data ? rt.data.data : []));
            else setTerritoires([]);
        }
        catch (err) {
            console.warn(err);
            setTerritoires([]);
        }

        // clients
        try {
            const rc = await axios.post('/api/clients_epfl.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (rc && rc.data) setClients(Array.isArray(rc.data) ? rc.data : (rc.data.data ? rc.data.data : []));
            else setClients([]);
        }
        catch (err) {
            console.warn(err);
            setClients([]);
        }

        // Récupération du RIB de l'organisme pour la facturation
        await axios.post('/api/organismes_rib.php', qs.stringify({
            'get': true,
            'id_organisme': props.user.id_organisme
        }))
        .then((res) => {
            if (res && res.data) {
                setIban(res.data.iban || '');
                setBic(res.data.bic || '');
            }
        })
        .catch((err) => {
            console.warn(err)
        })

        // Récupération du cachet de signature et du logo pour la facturation
        setTamponSignature(props.user.tampon_signature_organisme || '');
        setLogo(props.user.logo_organisme || '');

        // Récupération du téléphone et email de contact de l'organisme
        await axios.post('/api/organismes.php', qs.stringify({
            'getOrganismes': true,
            'id': props.user.id_organisme
        }))
        .then((res) => {
            if (res && res.data && res.data[0]) {
                setTelephone(res.data[0].telephone || '');
                setEmailContact(res.data[0].email_contact || '');
                setPiedPage(res.data[0].pied_page || '');
            }
        })
        .catch((err) => {
            console.warn(err);
        })

        // Récupération de l'adresse de l'organisme pour la facturation
        await axios.post('/api/organismes_adresse.php', qs.stringify({
            'get': true,
            'id_organisme': props.user.id_organisme
        }))
        .then((res) => {
            if (res && res.data) {
                setNum_voie(res.data.num_voie !== null && res.data.num_voie !== undefined ? String(res.data.num_voie) : '');
                setNum_suffixe(res.data.num_suffixe || '');
                setType_voie(res.data.type_voie || '');
                setNom_voie(res.data.nom_voie || '');
                setComplement_adresse(res.data.complement_adresse || '');
                setCode_postale(res.data.code_postale || '');
                setVille(res.data.ville || '');
            }
        })
        .catch((err) => {
            console.warn(err)
        })

        setAff(!aff);
    }


    async function create()
    {
        if (props.user.id_budget && props.user.id_budget !== null) {
            let numero = 0
            if (operations.length !== 0) {
                operations.forEach(projet => {
                    numero = projet[2]
                });
            }
            numero++;
            const params = {
                'create': true,
                'id_budget': props.user.id_budget,
                'user_id': props.user.id
            }
            await axios.post('/api/operations.php', qs.stringify(params))
            .then((result) => {
                if (result.data['status'] === 1) {
                    NotificationManager.success(result.data['message'], '', 700);
                    setTimeout(() => window.location = window.location.origin + '/operation/saisie/'+result.data.id_operation+'?new=true', 900);
                }
                else {
                    NotificationManager.warning(result.data['message'], '', 2000);
                }
            })
        }
    }


    async function facturation(liste, annee)
    {
        // Vérification de l'année
        if (!annee) {
            NotificationManager.warning('Veuillez sélectionner une année', '', 2000);
            return;
        }

        // Vérification de la liste
        if (!liste || liste.length === 0) {
            NotificationManager.warning('Aucune opération dans la liste filtrée', '', 2000);
            return;
        }

        // Vérification du RIB
        if (!iban || !bic) {
            NotificationManager.warning("Le RIB de votre organisme (IBAN / BIC) n'est pas renseigné. Veuillez le compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification du logo et du tampon de signature
        if (!props.user.logo_organisme || !props.user.tampon_signature_organisme) {
            NotificationManager.warning("Le logo ou le tampon de signature de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification de l'adresse
        if (!num_voie || !type_voie || !nom_voie || !code_postale || !ville) {
            NotificationManager.warning("L'adresse de votre organisme n'est pas renseignée. Veuillez la compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification du téléphone et de l'email de contact
        if (!telephone || !emailContact) {
            NotificationManager.warning("Le téléphone ou l'email de contact de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les avis.", '', 4000);
            return;
        }

        // Vérification du pied de page
        if (!piedPage) {
            NotificationManager.warning("Le pied de page de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les avis.", '', 4000);
            return;
        }

        const organismeInfo = {
            logo:              props.user.logo_organisme || '',
            tampon_signature:  props.user.tampon_signature_organisme || '',
            nom_organisme:     props.user.nom_organisme || '',
            iban,
            bic,
            num_voie,
            num_suffixe,
            type_voie,
            nom_voie,
            complement_adresse,
            code_postale,
            ville,
            telephone,
            email_contact: emailContact,
            pied_page: piedPage,
        };

        const date = new Date().toLocaleDateString('fr-FR', {
            day: '2-digit', month: 'long', year: 'numeric'
        });

        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const hh = String(now.getHours()).padStart(2, '0');
        const mn = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${dd}${mm}${hh}${mn}`;

        const echeance = new Date(now);
        echeance.setDate(echeance.getDate() + 30);
        const dateEcheance = `${String(echeance.getDate()).padStart(2, '0')}/${String(echeance.getMonth() + 1).padStart(2, '0')}/${echeance.getFullYear()}`;

        NotificationManager.info(`Génération de ${liste.length} facture(s)...`, '', 3000);

        for (let i = 0; i < liste.length; i++) {
            const op = liste[i];

            // Récupération des incidences financières de l'opération
            let incidances = null;
            let incidancesPrev = null;
            try {
                const res = await axios.post('/api/incidences_financieres_operations.php', qs.stringify({
                    action: 'get_by_operation',
                    id_operation: op.id,
                }));
                if (res.data && res.data.data) {
                    const all = res.data.data;
                    incidances     = all.find(inc => parseInt(inc.annee) === parseInt(annee)) || null;
                    incidancesPrev = all.find(inc => parseInt(inc.annee) === parseInt(annee) - 1) || null;
                }
            } catch (err) {
                console.warn('Erreur chargement incidences opération', op.id, err);
            }

            // Recherche du client complet (avec adresse)
            const client = clients.find(c => parseInt(c.id) === parseInt(op.id_clients_epfl)) || null;

            // Génération du PDF
            try {
                const refNum     = op.numero_inventaire || ('OP' + op.id);
                const numFacture = `${refNum}_${String(i + 1).padStart(2, '0')}_${timestamp}`;
                const fileName   = 'Facture_' + numFacture + '.pdf';

                const pdfBlob = await pdf(
                    <FacturePortagePDF
                        op={op}
                        annee={parseInt(annee)}
                        index={i + 1}
                        incidances={incidances}
                        incidancesPrev={incidancesPrev}
                        organisme={organismeInfo}
                        client={client}
                        date={date}
                        numFacture={numFacture}
                        dateEcheance={dateEcheance}
                    />
                ).toBlob();

                const url  = URL.createObjectURL(pdfBlob);
                const link = document.createElement('a');
                link.href  = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (err) {
                console.error('Erreur génération PDF pour opération', op.id, err);
                NotificationManager.error(`Erreur PDF : ${op.nom || op.id}`, '', 3000);
            }
        }

        NotificationManager.success('Factures générées avec succès', '', 2000);
    }

    async function facturationConsolidee(liste, annee)
    {
        // Vérification de l'année
        if (!annee) {
            NotificationManager.warning('Veuillez sélectionner une année', '', 2000);
            return;
        }

        // Vérification de la liste
        if (!liste || liste.length === 0) {
            NotificationManager.warning('Aucune opération sélectionnée', '', 2000);
            return;
        }

        // Vérification du RIB
        if (!iban || !bic) {
            NotificationManager.warning("Le RIB de votre organisme (IBAN / BIC) n'est pas renseigné. Veuillez le compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification du logo et du tampon de signature
        if (!props.user.logo_organisme || !props.user.tampon_signature_organisme) {
            NotificationManager.warning("Le logo ou le tampon de signature de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification de l'adresse
        if (!num_voie || !type_voie || !nom_voie || !code_postale || !ville) {
            NotificationManager.warning("L'adresse de votre organisme n'est pas renseignée. Veuillez la compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification du téléphone et de l'email de contact
        if (!telephone || !emailContact) {
            NotificationManager.warning("Le téléphone ou l'email de contact de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les avis.", '', 4000);
            return;
        }

        // Vérification du pied de page
        if (!piedPage) {
            NotificationManager.warning("Le pied de page de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les avis.", '', 4000);
            return;
        }

        const organismeInfo = {
            logo:              props.user.logo_organisme || '',
            tampon_signature:  props.user.tampon_signature_organisme || '',
            nom_organisme:     props.user.nom_organisme || '',
            iban,
            bic,
            num_voie,
            num_suffixe,
            type_voie,
            nom_voie,
            complement_adresse,
            code_postale,
            ville,
            telephone,
            email_contact: emailContact,
            pied_page: piedPage,
        };

        const date = new Date().toLocaleDateString('fr-FR', {
            day: '2-digit', month: 'long', year: 'numeric'
        });

        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const hh = String(now.getHours()).padStart(2, '0');
        const mn = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${dd}${mm}${hh}${mn}`;

        const echeance = new Date(now);
        echeance.setDate(echeance.getDate() + 30);
        const dateEcheance = `${String(echeance.getDate()).padStart(2, '0')}/${String(echeance.getMonth() + 1).padStart(2, '0')}/${echeance.getFullYear()}`;

        const firstOperation = liste[0] || null;
        const firstRefNum = firstOperation && firstOperation.numero_inventaire ? firstOperation.numero_inventaire : ('OP' + (firstOperation ? firstOperation.id : '0'));
        const numFacture = `${firstRefNum}_01_${timestamp}`;
        const firstClient = firstOperation ? (clients.find(c => parseInt(c.id) === parseInt(firstOperation.id_clients_epfl)) || null) : null;

        NotificationManager.info(`Génération d'une facture consolidée (${liste.length} opération(s))...`, '', 3000);

        const rows = [];
        for (let i = 0; i < liste.length; i++) {
            const op = liste[i];
            let incidances = null;
            try {
                const res = await axios.post('/api/incidences_financieres_operations.php', qs.stringify({
                    action: 'get_by_operation',
                    id_operation: op.id,
                }));
                if (res.data && res.data.data) {
                    const all = res.data.data;
                    incidances = all.find(inc => parseInt(inc.annee) === parseInt(annee)) || null;
                }
            } catch (err) {
                console.warn('Erreur chargement incidences opération', op.id, err);
            }

            rows.push({
                reference: op.numero_inventaire || ('OP' + op.id),
                operation: op.nom || '',
                amount: parseFloat(incidances?.frais_portage_ttc || 0),
            });
        }

        const totalAmount = rows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);

        try {
            const fileName = 'Facture_' + numFacture + '.pdf';

            const pdfBlob = await pdf(
                <FacturationSelectionPDF
                    mode="factures"
                    annee={parseInt(annee)}
                    date={date}
                    organisme={organismeInfo}
                    client={firstClient}
                    numFacture={numFacture}
                    dateEcheance={dateEcheance}
                    rows={rows}
                    totalAmount={totalAmount}
                />
            ).toBlob();

            const url  = URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href  = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Erreur génération facture consolidée', err);
            NotificationManager.error('Erreur génération facture consolidée', '', 3000);
            return;
        }

        NotificationManager.success('Facture consolidée générée avec succès', '', 2000);
    }


    async function avisEcheance(liste, annee)
    {
        // Vérification de l'année
        if (!annee) {
            NotificationManager.warning('Veuillez sélectionner une année', '', 2000);
            return;
        }

        // Vérification de la liste
        if (!liste || liste.length === 0) {
            NotificationManager.warning('Aucune opération dans la liste filtrée', '', 2000);
            return;
        }

        // Vérification du RIB
        if (!iban || !bic) {
            NotificationManager.warning("Le RIB de votre organisme (IBAN / BIC) n'est pas renseigné. Veuillez le compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification du logo et du tampon de signature
        if (!props.user.logo_organisme || !props.user.tampon_signature_organisme) {
            NotificationManager.warning("Le logo ou le tampon de signature de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification de l'adresse
        if (!num_voie || !type_voie || !nom_voie || !code_postale || !ville) {
            NotificationManager.warning("L'adresse de votre organisme n'est pas renseignée. Veuillez la compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification du téléphone et de l'email de contact
        if (!telephone || !emailContact) {
            NotificationManager.warning("Le téléphone ou l'email de contact de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les avis.", '', 4000);
            return;
        }

        // Vérification du pied de page
        if (!piedPage) {
            NotificationManager.warning("Le pied de page de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les avis.", '', 4000);
            return;
        }

        const organismeInfo = {
            logo:             props.user.logo_organisme || '',
            tampon_signature: props.user.tampon_signature_organisme || '',
            nom_organisme:    props.user.nom_organisme || '',
            iban,
            bic,
            num_voie,
            num_suffixe,
            type_voie,
            nom_voie,
            complement_adresse,
            code_postale,
            ville,
            telephone,
            email_contact: emailContact,
            pied_page: piedPage,
        };

        const date = new Date().toLocaleDateString('fr-FR', {
            day: '2-digit', month: 'long', year: 'numeric'
        });

        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const hh = String(now.getHours()).padStart(2, '0');
        const mn = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${dd}${mm}${hh}${mn}`;

        const echeance = new Date(now);
        echeance.setDate(echeance.getDate() + 30);
        const dateEcheance = `${String(echeance.getDate()).padStart(2, '0')}/${String(echeance.getMonth() + 1).padStart(2, '0')}/${echeance.getFullYear()}`;

        NotificationManager.info(`Génération de ${liste.length} avis d'échéance...`, '', 3000);

        for (let i = 0; i < liste.length; i++) {
            const op = liste[i];

            let incidances = null;
            try {
                const res = await axios.post('/api/incidences_financieres_operations.php', qs.stringify({
                    action: 'get_by_operation',
                    id_operation: op.id,
                }));
                if (res.data && res.data.data) {
                    const all = res.data.data;
                    incidances = all.find(inc => parseInt(inc.annee) === parseInt(annee)) || null;
                }
            } catch (err) {
                console.warn('Erreur chargement incidences opération', op.id, err);
            }

            const client = clients.find(c => parseInt(c.id) === parseInt(op.id_clients_epfl)) || null;

            try {
                const refNum     = op.numero_inventaire || ('OP' + op.id);
                const numFacture = `${refNum}_${String(i + 1).padStart(2, '0')}_${timestamp}`;
                const fileName   = 'AvisEcheance_' + numFacture + '.pdf';

                const pdfBlob = await pdf(
                    <AvisEcheancePDF
                        op={op}
                        annee={parseInt(annee)}
                        index={i + 1}
                        incidances={incidances}
                        organisme={organismeInfo}
                        client={client}
                        date={date}
                        numFacture={numFacture}
                        dateEcheance={dateEcheance}
                    />
                ).toBlob();

                const url  = URL.createObjectURL(pdfBlob);
                const link = document.createElement('a');
                link.href  = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (err) {
                console.error('Erreur génération avis pour opération', op.id, err);
                NotificationManager.error(`Erreur avis : ${op.nom || op.id}`, '', 3000);
            }
        }

        NotificationManager.success("Avis d'échéance générés avec succès", '', 2000);
    }

    async function avisEcheanceConsolide(liste, annee)
    {
        // Vérification de l'année
        if (!annee) {
            NotificationManager.warning('Veuillez sélectionner une année', '', 2000);
            return;
        }

        // Vérification de la liste
        if (!liste || liste.length === 0) {
            NotificationManager.warning('Aucune opération sélectionnée', '', 2000);
            return;
        }

        // Vérification du RIB
        if (!iban || !bic) {
            NotificationManager.warning("Le RIB de votre organisme (IBAN / BIC) n'est pas renseigné. Veuillez le compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification du logo et du tampon de signature
        if (!props.user.logo_organisme || !props.user.tampon_signature_organisme) {
            NotificationManager.warning("Le logo ou le tampon de signature de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification de l'adresse
        if (!num_voie || !type_voie || !nom_voie || !code_postale || !ville) {
            NotificationManager.warning("L'adresse de votre organisme n'est pas renseignée. Veuillez la compléter avant de générer les factures.", '', 4000);
            return;
        }

        // Vérification du téléphone et de l'email de contact
        if (!telephone || !emailContact) {
            NotificationManager.warning("Le téléphone ou l'email de contact de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les avis.", '', 4000);
            return;
        }

        // Vérification du pied de page
        if (!piedPage) {
            NotificationManager.warning("Le pied de page de votre organisme n'est pas renseigné. Veuillez le compléter avant de générer les avis.", '', 4000);
            return;
        }

        const organismeInfo = {
            logo:             props.user.logo_organisme || '',
            tampon_signature: props.user.tampon_signature_organisme || '',
            nom_organisme:    props.user.nom_organisme || '',
            iban,
            bic,
            num_voie,
            num_suffixe,
            type_voie,
            nom_voie,
            complement_adresse,
            code_postale,
            ville,
            telephone,
            email_contact: emailContact,
            pied_page: piedPage,
        };

        const date = new Date().toLocaleDateString('fr-FR', {
            day: '2-digit', month: 'long', year: 'numeric'
        });

        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const hh = String(now.getHours()).padStart(2, '0');
        const mn = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${dd}${mm}${hh}${mn}`;

        const echeance = new Date(now);
        echeance.setDate(echeance.getDate() + 30);
        const dateEcheance = `${String(echeance.getDate()).padStart(2, '0')}/${String(echeance.getMonth() + 1).padStart(2, '0')}/${echeance.getFullYear()}`;

        const firstOperation = liste[0] || null;
        const firstRefNum = firstOperation && firstOperation.numero_inventaire ? firstOperation.numero_inventaire : ('OP' + (firstOperation ? firstOperation.id : '0'));
        const numFacture = `${firstRefNum}_01_${timestamp}`;
        const firstClient = firstOperation ? (clients.find(c => parseInt(c.id) === parseInt(firstOperation.id_clients_epfl)) || null) : null;

        NotificationManager.info(`Génération d'un avis d'échéance consolidé (${liste.length} opération(s))...`, '', 3000);

        const rows = [];
        for (let i = 0; i < liste.length; i++) {
            const op = liste[i];
            let incidances = null;
            try {
                const res = await axios.post('/api/incidences_financieres_operations.php', qs.stringify({
                    action: 'get_by_operation',
                    id_operation: op.id,
                }));
                if (res.data && res.data.data) {
                    const all = res.data.data;
                    incidances = all.find(inc => parseInt(inc.annee) === parseInt(annee)) || null;
                }
            } catch (err) {
                console.warn('Erreur chargement incidences opération', op.id, err);
            }

            rows.push({
                reference: op.numero_inventaire || ('OP' + op.id),
                operation: op.nom || '',
                amount: parseFloat(incidances?.annuite_definitive || 0),
            });
        }

        const totalAmount = rows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);

        try {
            const fileName = 'AvisEcheance_' + numFacture + '.pdf';

            const pdfBlob = await pdf(
                <FacturationSelectionPDF
                    mode="avis"
                    annee={parseInt(annee)}
                    date={date}
                    organisme={organismeInfo}
                    client={firstClient}
                    numFacture={numFacture}
                    dateEcheance={dateEcheance}
                    rows={rows}
                    totalAmount={totalAmount}
                />
            ).toBlob();

            const url  = URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href  = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Erreur génération avis consolidé', err);
            NotificationManager.error("Erreur génération avis d'échéance consolidé", '', 3000);
            return;
        }

        NotificationManager.success("Avis d'échéance consolidé généré avec succès", '', 2000);
    }

    function openGenerationModal(type)
    {
        if (!anneeSelectionnee) {
            NotificationManager.warning('Veuillez sélectionner une année', '', 2000);
            return;
        }
        const selectedList = getSelectedOperationsForFacturation();
        if (!selectedList) return;
        setPendingOperations(selectedList);
        setGenerationType(type);
        setGenerationModalVisible(true);
    }

    async function handleGenerateWithMode(mode)
    {
        if (!generationType || !pendingOperations || pendingOperations.length === 0) {
            setGenerationModalVisible(false);
            return;
        }

        setIsGenerating(true);
        try {
            if (generationType === 'avis') {
                if (mode === 'single') {
                    await avisEcheanceConsolide(pendingOperations, anneeSelectionnee);
                } else {
                    await avisEcheance(pendingOperations, anneeSelectionnee);
                }
            }
            if (generationType === 'factures') {
                if (mode === 'single') {
                    await facturationConsolidee(pendingOperations, anneeSelectionnee);
                } else {
                    await facturation(pendingOperations, anneeSelectionnee);
                }
            }
        } finally {
            setIsGenerating(false);
            setGenerationModalVisible(false);
            setGenerationType(null);
            setPendingOperations([]);
        }
    }

    
    async function recalculateProspective()
    {
        try {
            const params = {
                action: 'recalculate_prospective',
                id_budget: props.user.id_budget,
                prosp_an_deb: props.user.config_budget.prosp_an_deb,
                prosp_an_fin: props.user.config_budget.prosp_an_fin
            };
            
            await axios.post('/api/incidences_financieres_operations.php', qs.stringify(params))
            .then((response) => {
                if (!response.data || response.data.status !== 1) {
                    throw new Error(response.data?.message || 'Erreur lors du recalcul des prospectives');
                }
                else {
                    NotificationManager.success('Opération mise à jour', '', 2000);
                    // setLoading(false);
                }
            })
            .catch((error) => {
                console.warn('Erreur lors du recalcul des prospectives:', error);
                throw error;
            });
        } catch (err) {
            console.warn('Erreur lors du recalcul des prospectives:', err);
        }
    }

    async function suppressProjet(id)
    {
        try {
            setIsRecalculating(true);
            const res = await axios.post('/api/operations.php', qs.stringify({ delete: true, id: id }));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success('Opération supprimée', '', 1500);
                await recalculateProspective();
                await mount();
            } else {
                NotificationManager.error('Erreur suppression', '', 2000);
            }
        } catch (err) {
            console.warn(err);
            NotificationManager.error('Erreur serveur', '', 2000);
        } finally {
            setIsRecalculating(false);
        }
    }

    async function toggleCheckbox(id, field, currentValue)
    {
        try {
            setIsRecalculating(true);
            const newValue = currentValue === "1" || currentValue === 1 ? 0 : 1;
            const params = {
                update: true,
                id: id,
                [field]: newValue
            };
            const res = await axios.post('/api/operations.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                await recalculateProspective();
                await mount();
            } else {
                NotificationManager.error('Erreur mise à jour', '', 2000);
            }
        } catch (err) {
            console.warn(err);
            NotificationManager.error('Erreur serveur', '', 2000);
        } finally {
            setIsRecalculating(false);
        }
    }

    useEffect(() => {
        if (props.user === null) {
            props.getUser();
        } else {
            mount();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.user]);

    useEffect(() => {
        setSelectedOperations((prev) => {
            const validIds = new Set((operations || []).map((op) => String(op.id)));
            const next = {};
            Object.keys(prev || {}).forEach((id) => {
                if (prev[id] && validIds.has(String(id))) {
                    next[id] = true;
                }
            });
            return next;
        });
    }, [operations]);

    // tri avec ordre croissant/décroissant
    const sortBy = (field) => {
        let newOrder = 'asc';
        if (sortField === field && sortOrder === 'asc') {
            newOrder = 'desc';
        }
        setSortField(field);
        setSortOrder(newOrder);
        
        setOperations(prev => {
            const copy = Array.isArray(prev) ? [...prev] : [];
            copy.sort((a, b) => {
                const va = a && a[field] !== undefined && a[field] !== null ? a[field] : '';
                const vb = b && b[field] !== undefined && b[field] !== null ? b[field] : '';
                
                let comparison = 0;
                // si nombres
                if (field === 'montant' || field === 'id' || field === 'id_modalite_portage') {
                    comparison = parseFloat(va || 0) - parseFloat(vb || 0);
                } else {
                    comparison = ('' + va).toString().localeCompare(('' + vb).toString());
                }
                
                return newOrder === 'asc' ? comparison : -comparison;
            });
            return copy;
        });
        setAff(!aff);
    };

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    const normalizeId = (value) => {
        if (value === null || value === undefined || value === '') return null;
        const n = parseInt(String(value).trim(), 10);
        return Number.isNaN(n) ? null : n;
    };

    const matchesIdFilter = (opValue, filterValue) => {
        if (!filterValue || filterValue === '') return true;
        const opId = normalizeId(opValue);
        const filterId = normalizeId(filterValue);
        if (opId === null || filterId === null) return false;
        return opId === filterId;
    };

    const isCheckedHypothesis = (value) => {
        return value === "1" || value === 1 || value === true || value === "true";
    };

    const filtered = operations.filter(op => {
        // Filtre modalité
        if (!matchesIdFilter(op.id_modalite_portage, modaliteFilter)) return false;
        // Filtre axe d'intervention
        if (!matchesIdFilter(op.id_axes_interventions, axeFilter)) return false;
        // Filtre territoire
        if (!matchesIdFilter(op.id_territoires, territoireFilter)) return false;
        // Filtre client
        if (!matchesIdFilter(op.id_clients_epfl, clientFilter)) return false;
        // Filtre hypothèse
        if (hypotheseFilter && hypotheseFilter !== '') {
            const hypotheseValue = op[hypotheseFilter];
            if (!isCheckedHypothesis(hypotheseValue)) return false;
        }
        // Filtre recherche nom (insensible aux accents)
        if (searchText && searchText.trim() !== '') {
            const search = removeAccents(searchText.toLowerCase());
            const nom = removeAccents((op.nom || '').toLowerCase());
            if (!nom.includes(search)) return false;
        }
        // Filtre recherche numéro
        if (searchNumero && searchNumero.trim() !== '') {
            const numero = (op.numero_inventaire || '').toLowerCase();
            if (!numero.includes(searchNumero.toLowerCase())) return false;
        }
        return true;
    });

    function toggleOperationSelection(operationId)
    {
        setSelectedOperations((prev) => ({
            ...prev,
            [operationId]: !prev[operationId]
        }));
    }

    function isOperationSelected(operationId)
    {
        return !!selectedOperations[operationId];
    }

    function toggleAllFilteredOperations(checked)
    {
        setSelectedOperations((prev) => {
            const next = { ...prev };
            filtered.forEach((op) => {
                next[op.id] = checked;
            });
            return next;
        });
    }

    const selectedCount = operations.filter((op) => selectedOperations[op.id]).length;
    const selectedFilteredCount = filtered.filter((op) => selectedOperations[op.id]).length;
    const allFilteredSelected = filtered.length > 0 && selectedFilteredCount === filtered.length;

    function getSelectedOperationsForFacturation()
    {
        const selectedList = operations.filter((op) => selectedOperations[op.id]);
        if (!selectedList || selectedList.length === 0) {
            NotificationManager.warning('Aucune opération sélectionnée', '', 2000);
            return null;
        }
        return selectedList;
    }

    return (
        <div>
            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
            <Access needConnection={true} type_user={[0]}>
                <Navbar user={props.user} />

                <Dialog
                    setModalVisible={setDialogModalVisible}
                    modalVisible={dialogModalVisible}
                    callbackDialog={callbackDialog}
                    message={"Confirmez la suppression :"}
                />

                <div style={{display: 'flex'}}>
                    <div style={{flex: 1, margin: 20, display: 'flex'}}>
                        <div style={{flex: 1, display: 'flex'}}>
                            <p>Gestion</p>
                            <p style={{marginLeft: 5}}>\</p>
                            <p style={{marginLeft: 5, color: purple, fontWeight: 'bold'}}>Opérations</p>
                        </div>

                        <div style={{flex: 1}}>
                            {props.user?
                            <p style={{flex: 1, textAlign: 'center'}}>{props.user.nom_budget}</p>
                            :null}
                        </div>

                        <div style={{flex: 1}}>
                        {isRecalculating && (
                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                                    <div style={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: '50%',
                                        border: '3px solid #ddd',
                                        borderTop: '3px solid ' + purple,
                                        animation: 'spin 1s linear infinite'
                                    }}></div>
                                    <p style={{margin: 0, color: purple, fontWeight: 600}}>Recalcul des restitutions...</p>
                                </div>
                            </div>
                        )}
                        </div>
                    </div>
                </div>

                <div style={{flex: 1, margin: 20, display: 'flex'}}>
                    <div style={{flex: 1}}></div>
                    <button
                        className='shadow-md p-2 rounded-md'
                        style={ongletListeOperations?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                        onClick={() => {
                            setOngletListeOperations(true);
                            setOngletSyntheseGantt(false);
                            setOngletIncidencesFinancieres(false);
                            setOngletFacturationEpfl(false);
                        }}
                    >
                        Liste des opérations
                    </button>

                    <button
                        className='shadow-md p-2 rounded-md'
                        style={ongletIncidencesFinancieres?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                        onClick={() => {
                            setOngletListeOperations(false);
                            setOngletSyntheseGantt(false);
                            setOngletIncidencesFinancieres(true);
                            setOngletFacturationEpfl(false);
                        }}
                    >
                        Incidences Financières
                    </button>

                    <button
                        className='shadow-md p-2 rounded-md'
                        style={ongletSyntheseGantt?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                        onClick={() => {
                            setOngletListeOperations(false);
                            setOngletSyntheseGantt(true);
                            setOngletIncidencesFinancieres(false);
                            setOngletFacturationEpfl(false);
                        }}
                    >
                        Synthèse des opérations (GANTT)
                    </button>


                    {props.user && (props.user.id_type_users == 1 || props.user.id_type_users == 2) && 
                    <button
                        className='shadow-md p-2 rounded-md'
                        style={ongletFacturationEpfl?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                        onClick={() => {
                            setOngletListeOperations(false);
                            setOngletSyntheseGantt(false);
                            setOngletIncidencesFinancieres(false);
                            setOngletFacturationEpfl(true);
                        }}
                    >
                        Facturation
                    </button>
                    }
                    <div style={{flex: 1}}></div>
                </div>

                {ongletListeOperations?
                <div style={{display: 'flex'}}>
                    <div style={{flex: 1}}></div>
                    <button
                        className='shadow-md rounded-md'
                        style={{backgroundColor: green, color: 'white', fontSize: 14, margin: 10, paddingLeft: 10, paddingRight: 10}}
                        onClick={() => {
                            create()
                        }}
                    >
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <Add width="12" />
                            <p style={{marginLeft: 5}}>Créer une opération</p>
                        </div>
                    </button>
                    <div style={{flex: 1}}></div>
                </div>
                :null}

                {ongletFacturationEpfl?
                <div style={{display: 'flex'}}>
                    <div style={{flex: 1}}></div>

                    {/* Select année */}
                    <select 
                        style={{margin: 10, padding: 10}}
                        value={anneeSelectionnee || ''}
                        onChange={(e) => setAnneeSelectionnee(parseInt(e.target.value))}
                    >
                        <option value="">Sélectionnez une année</option>
                        {
                            annees.map((annee, index) => (
                                <option key={index} value={annee}>{annee}</option>
                            ))
                        }
                    </select>
                    
                    <button
                        className='shadow-md rounded-md'
                        style={{backgroundColor: green, color: 'white', fontSize: 14, margin: 10, paddingLeft: 10, paddingRight: 10}}
                        onClick={() => {
                            openGenerationModal('avis');
                        }}
                    >
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <Add width="12" />
                            <p style={{marginLeft: 5}}>Avis d'échéance</p>
                        </div>
                    </button>

                    <button
                        className='shadow-md rounded-md'
                        style={{backgroundColor: green, color: 'white', fontSize: 14, margin: 10, paddingLeft: 10, paddingRight: 10}}
                        onClick={() => {
                            openGenerationModal('factures');
                        }}
                    >
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <Add width="12" />
                            <p style={{marginLeft: 5}}>Factures</p>
                        </div>
                    </button>
                    <div style={{flex: 1}}></div>
                </div>
                :null}

                {generationModalVisible ? (
                    <div style={{position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.35)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999}}>
                        <div className='shadow-md' style={{backgroundColor: '#fff', borderRadius: 10, width: 'min(760px, 95vw)', maxWidth: 760, padding: 0, overflow: 'hidden'}}>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 18px', backgroundColor: purple, color: 'white'}}>
                                <div style={{fontWeight: '700'}}>
                                    Choix du mode de génération
                                </div>
                                <button
                                    onClick={() => {
                                        if (isGenerating) return;
                                        setGenerationModalVisible(false);
                                        setGenerationType(null);
                                        setPendingOperations([]);
                                    }}
                                    style={{background: 'transparent', border: 'none', color: 'white', fontSize: 18, cursor: isGenerating ? 'default' : 'pointer'}}
                                    disabled={isGenerating}
                                >
                                    ×
                                </button>
                            </div>

                            <div style={{padding: 18, display: 'flex', flexDirection: 'column', gap: 12}}>
                                <p style={{margin: 0, fontSize: 15, color: '#222'}}>
                                    Souhaitez-vous générer un seul document (1 ligne par opération) ou plusieurs documents (1 opération par document) ?
                                </p>
                                <p style={{margin: 0, fontSize: 13, color: '#6B7280'}}>
                                    {pendingOperations.length} opération(s) sélectionnée(s) • Année {anneeSelectionnee}
                                </p>
                            </div>

                            <div style={{display: 'flex', justifyContent: 'space-between', gap: 10, padding: '12px 18px', borderTop: '1px solid #F3F4F6', backgroundColor: '#FAFBFF'}}>
                                <button
                                    onClick={() => {
                                        if (!isGenerating) {
                                            setGenerationModalVisible(false);
                                            setGenerationType(null);
                                            setPendingOperations([]);
                                        }
                                    }}
                                    style={{padding: '8px 14px', borderRadius: 8, backgroundColor: '#F3F4F6', border: '1px solid #E5E7EB', cursor: isGenerating ? 'default' : 'pointer'}}
                                    disabled={isGenerating}
                                >
                                    Annuler
                                </button>

                                <div style={{display: 'flex', gap: 10}}>
                                    <button
                                        onClick={() => handleGenerateWithMode('single')}
                                        disabled={isGenerating}
                                        style={{padding: '8px 16px', borderRadius: 8, backgroundColor: '#EEF2FF', color: '#2F3AA0', border: '1px solid #C7D2FE', cursor: isGenerating ? 'default' : 'pointer', fontWeight: 600}}
                                    >
                                        Un seul PDF (1 ligne par opération)
                                    </button>
                                    <button
                                        onClick={() => handleGenerateWithMode('multiple')}
                                        disabled={isGenerating}
                                        style={{padding: '8px 16px', borderRadius: 8, backgroundColor: purple, color: 'white', border: 'none', cursor: isGenerating ? 'default' : 'pointer', fontWeight: 600}}
                                    >
                                        Plusieurs PDF (1 PDF par opération)
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                {ongletListeOperations || ongletFacturationEpfl?
                <>
                <div style={{margin: '0 25px 25px 25px', padding: 20, backgroundColor: '#f8f9fa', borderRadius: 8, border: '1px solid #e0e0e0'}}>
                    <div style={{display: 'flex', alignItems: 'center', marginBottom: 15}}>
                        <p style={{fontSize: 16, fontWeight: 600, color: '#333', margin: 0}}>Filtres</p>
                        <div style={{flex: 1}}></div>
                        <button
                            className='shadow-sm'
                            style={{
                                padding: '8px 16px',
                                borderRadius: 4,
                                border: '1px solid #ccc',
                                backgroundColor: 'white',
                                fontSize: 13,
                                cursor: 'pointer',
                                color: '#666',
                                transition: 'all 0.2s'
                            }}
                            onClick={() => {
                                setSearchNumero('');
                                setSearchText('');
                                setClientFilter('');
                                setAxeFilter('');
                                setTerritoireFilter('');
                                setModaliteFilter('');
                                setHypotheseFilter('');
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f0f0f0';
                                e.currentTarget.style.borderColor = '#999';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'white';
                                e.currentTarget.style.borderColor = '#ccc';
                            }}
                        >
                            Réinitialiser les filtres
                        </button>
                    </div>
                    
                    <div style={{display: 'flex', gap: 15, marginBottom: 15}}>
                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Rechercher par numéro</p>
                            <input
                                type="text"
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14}}
                                placeholder="Numéro d'inventaire..."
                                value={searchNumero}
                                onChange={e => setSearchNumero(e.target.value)}
                            />
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Rechercher par nom</p>
                            <input
                                type="text"
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14}}
                                placeholder="Nom de l'opération..."
                                value={searchText}
                                onChange={e => setSearchText(e.target.value)}
                            />
                        </div>
                    </div>

                    <div style={{display: 'flex', gap: 15}}>
                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Collectivités</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={clientFilter}
                                onChange={e => setClientFilter(e.target.value)}
                            >
                                <option value=''>Liste des collectivités</option>
                                {clients.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nom}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Axe d'intervention</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={axeFilter}
                                onChange={e => setAxeFilter(e.target.value)}
                            >
                                <option value=''>Tous les axes</option>
                                {axes.map((a) => (
                                    <option key={a.id} value={a.id}>{a.intitule}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Territoires</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={territoireFilter}
                                onChange={e => setTerritoireFilter(e.target.value)}
                            >
                                <option value=''>Tous les territoires</option>
                                {territoires.map((t) => (
                                    <option key={t.id} value={t.id}>{t.intitule}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Modalité de portage</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={modaliteFilter}
                                onChange={e => setModaliteFilter(e.target.value)}
                            >
                                <option value=''>Toutes les modalités</option>
                                {modalites.map((m) => (
                                    <option key={m.id} value={m.id}>{m.intitule}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Hypothèse</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={hypotheseFilter}
                                onChange={e => setHypotheseFilter(e.target.value)}
                            >
                                <option value=''>Toutes les hypothèses</option>
                                <option value='h1'>Hypothèse 1</option>
                                <option value='h2'>Hypothèse 2</option>
                                <option value='h3'>Hypothèse 3</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div style={{margin: 25}}>
                    {ongletFacturationEpfl ? (
                        <div style={{display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 12}}>
                            <button
                                className='shadow-md'
                                onClick={() => {
                                    toggleAllFilteredOperations(true);
                                }}
                                style={{padding: '6px 10px', borderRadius: 4, backgroundColor: '#EEF2FF', color: '#2F3AA0'}}
                            >
                                Tout sélectionner (filtre)
                            </button>
                            <button
                                className='shadow-md'
                                onClick={() => {
                                    toggleAllFilteredOperations(false);
                                }}
                                style={{padding: '6px 10px', borderRadius: 4, backgroundColor: '#F5F5F5'}}
                            >
                                Tout désélectionner (filtre)
                            </button>
                            <p style={{fontSize: 13, opacity: 0.85, margin: 0}}>{selectedFilteredCount} sélectionnée(s) sur {filtered.length} visible(s)</p>
                            <div style={{flex: 1}}></div>
                            <p style={{fontSize: 13, opacity: 0.85, margin: 0}}>{selectedCount} opération(s) sélectionnée(s) au total</p>
                        </div>
                    ) : null}

                    {(!filtered || filtered.length === 0) ? (
                        <div style={{color: '#666', textAlign: 'center', marginTop: 25}}>Aucune opération pour ce budget</div>
                    ) : (
                        <>
                            <div style={{display: 'flex', padding: '8px 12px', borderBottom: '1px solid #ddd', alignItems: 'center', fontWeight: 600, color: '#333'}}>
                                <div style={{width:30, textAlign:'center'}}>
                                    {ongletFacturationEpfl ? (
                                        <input
                                            type="checkbox"
                                            checked={allFilteredSelected}
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                toggleAllFilteredOperations(!allFilteredSelected);
                                            }}
                                        />
                                    ) : null}
                                </div>
                                <div style={{width:50, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('color')}>
                                    État {sortField === 'color' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:1.5, minWidth:120, cursor:'pointer', display:'flex', alignItems:'center'}} onClick={() => sortBy('numero_inventaire')}>
                                    Numéro {sortField === 'numero_inventaire' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2.5, minWidth:0, cursor:'pointer', display:'flex', alignItems:'center'}} onClick={() => sortBy('nom')}>
                                    Intitulé {sortField === 'nom' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('nom_client')}>
                                    Collectivités {sortField === 'nom_client' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('nom_axe')}>
                                    Axe d'intervention {sortField === 'nom_axe' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('nom_territoire')}>
                                    Territoires {sortField === 'nom_territoire' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('nom_modalite')}>
                                    Modalités de portage {sortField === 'nom_modalite' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{width: 90}}>
                                    <div>Hypothèses</div>
                                    <div style={{display:'flex', justifyContent:'space-between', fontSize:12, fontWeight:600}}>
                                        <div style={{width:30, textAlign:'center'}}>H1</div>
                                        <div style={{width:30, textAlign:'center'}}>H2</div>
                                        <div style={{width:30, textAlign:'center'}}>H3</div>
                                    </div>
                                </div>
                            </div>

                            <div style={{display:'flex', flexDirection:'column', gap:8, marginTop:8}}>
                                {filtered.map((op) => (
                                    <div 
                                        key={op.id} 
                                        style={{display: 'flex', width: '100%', padding: '12px', borderRadius: 6, border: '1px solid #eee', background: 'white', alignItems: 'center', cursor: 'pointer', transition: 'background 0.2s'}}
                                        onClick={() => {
                                            if (ongletFacturationEpfl) {
                                                toggleOperationSelection(op.id);
                                            } else {
                                                history.push('/operation/saisie/' + op.id + '?timestamp=' + new Date().getTime());
                                            }
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
                                        onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                                    >
                                        <div style={{width:30, textAlign:'center'}}>
                                            {ongletFacturationEpfl ? (
                                                <input
                                                    type="checkbox"
                                                    checked={isOperationSelected(op.id)}
                                                    onChange={(e) => {
                                                        e.stopPropagation();
                                                        toggleOperationSelection(op.id);
                                                    }}
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                            ) : (
                                                <button onClick={async (e) => {
                                                    e.stopPropagation();
                                                    await setIdSelected(op.id);
                                                    setDialogModalVisible(true);
                                                }} style={{border:'none', background:'transparent', cursor:'pointer', padding: '8px 12px'}}>
                                                    <Trash width="18" />
                                                </button>
                                            )}
                                        </div>
                                        <div style={{width:50, textAlign:'center'}}>
                                            <div style={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: '50%',
                                                backgroundColor: (op.color && op.color !== '') ? op.color : '',
                                                margin: '0 auto'
                                            }}></div>
                                        </div>
                                        <div style={{flex:1.5, minWidth:120, fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{op.numero_inventaire || ''}</div>
                                        <div style={{flex:2.5, minWidth:0, fontSize: 14, fontWeight: 'bold'}}>{op.nom || ''}</div>
                                        <div style={{flex:2, textAlign:'center', fontSize: 12}}>{op.nom_client || ''}</div>
                                        <div style={{flex:2, textAlign:'center', fontSize: 12}}>{op.nom_axe || ''}</div>
                                        <div style={{flex:2, textAlign:'center', fontSize: 12}}>{op.nom_territoire || ''}</div>
                                        <div style={{flex:2, textAlign:'center', fontSize: 12}}>{op.nom_modalite || ''}</div>
                                        <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox" 
                                                checked={op.h1 === "1" || op.h1 === 1} 
                                                onChange={() => toggleCheckbox(op.id, 'h1', op.h1)}
                                                style={{cursor: 'pointer'}}
                                            />
                                        </div>
                                        <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox" 
                                                checked={op.h2 === "1" || op.h2 === 1} 
                                                onChange={() => toggleCheckbox(op.id, 'h2', op.h2)}
                                                style={{cursor: 'pointer'}}
                                            />
                                        </div>
                                        <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox" 
                                                checked={op.h3 === "1" || op.h3 === 1} 
                                                onChange={() => toggleCheckbox(op.id, 'h3', op.h3)}
                                                style={{cursor: 'pointer'}}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
                </>
                :null}

                {ongletSyntheseGantt?
                <div style={{flex: 1, textAlign: 'center', marginTop: 10, marginLeft: 30, marginRight: 30, marginBottom: 30}}>
                    <GanttSyntheseOperations user={props.user} listeOperations={operations} />
                </div>
                :null}

                {ongletIncidencesFinancieres?
                <IncidendesFinancieresGlobalOperations 
                    anneeDebut={anneeDebut}
                    setAnneeDebut={setAnneeDebut}
                    anneeFin={anneeFin}
                    setAnneeFin={setAnneeFin}
                    user={props.user}
                    onValider={() => {
                        console.log('Valider clicked', { anneeDebut, anneeFin });
                    }}
                />
                :null}

            </Access>
        </div>
    );
}

export default Operations;
